// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  AddMySystemData,
  AddMySystemResponses,
  BulkCombinedFactorFromLleData,
  BulkCombinedFactorFromLleResponses,
  BulkCombinedFactorFromLlhData,
  BulkCombinedFactorFromLlhResponses,
  BulkCombinedFactorFromNeeData,
  BulkCombinedFactorFromNeeResponses,
  BulkCombinedFactorFromNehData,
  BulkCombinedFactorFromNehResponses,
  BulkCombinedFactorFromXyzData,
  BulkCombinedFactorFromXyzResponses,
  BulkConvergenceFromLleData,
  BulkConvergenceFromLleResponses,
  BulkConvergenceFromLlhData,
  BulkConvergenceFromLlhResponses,
  BulkConvergenceFromNeeData,
  BulkConvergenceFromNeeResponses,
  BulkConvergenceFromNehData,
  BulkConvergenceFromNehResponses,
  BulkConvergenceFromXyzData,
  BulkConvergenceFromXyzResponses,
  BulkLleFromLlhData,
  BulkLleFromLlhResponses,
  BulkLleFromNeeData,
  BulkLleFromNeeResponses,
  BulkLleFromNehData,
  BulkLleFromNehResponses,
  BulkLleFromXyzData,
  BulkLleFromXyzResponses,
  BulkLlhFromLleData,
  BulkLlhFromLleResponses,
  BulkLlhFromLlhData,
  BulkLlhFromLlhResponses,
  BulkLlhFromNeeData,
  BulkLlhFromNeeResponses,
  BulkLlhFromNehData,
  BulkLlhFromNehResponses,
  BulkLlhFromXyzData,
  BulkLlhFromXyzResponses,
  BulkNeeFromLleData,
  BulkNeeFromLleResponses,
  BulkNeeFromLlhData,
  BulkNeeFromLlhResponses,
  BulkNeeFromNehData,
  BulkNeeFromNehResponses,
  BulkNeeFromXyzData,
  BulkNeeFromXyzResponses,
  BulkNehFromLleData,
  BulkNehFromLleResponses,
  BulkNehFromLlhData,
  BulkNehFromLlhResponses,
  BulkNehFromNeeData,
  BulkNehFromNeeResponses,
  BulkNehFromXyzData,
  BulkNehFromXyzResponses,
  BulkScaleFactorFromLleData,
  BulkScaleFactorFromLleResponses,
  BulkScaleFactorFromLlhData,
  BulkScaleFactorFromLlhResponses,
  BulkScaleFactorFromNeeData,
  BulkScaleFactorFromNeeResponses,
  BulkScaleFactorFromNehData,
  BulkScaleFactorFromNehResponses,
  BulkScaleFactorFromXyzData,
  BulkScaleFactorFromXyzResponses,
  BulkXyzFromLleData,
  BulkXyzFromLleResponses,
  BulkXyzFromLlhData,
  BulkXyzFromLlhResponses,
  BulkXyzFromNeeData,
  BulkXyzFromNeeResponses,
  BulkXyzFromNehData,
  BulkXyzFromNehResponses,
  CoordinatesReadmeData,
  CoordinatesReadmeResponses,
  CoordinateSystemsReadmeData,
  CoordinateSystemsReadmeResponses,
  CreateCoordinateSystemData,
  CreateCoordinateSystemResponses,
  DeleteMySystemData,
  DeleteMySystemResponses,
  DownloadCoordSystemDatabaseData,
  DownloadCoordSystemDatabaseResponses,
  DownloadGeodataFileData,
  DownloadTimeDependentTransformationDatabaseData,
  GetAliasData,
  GetAliasResponses,
  GetAreaData,
  GetAreaResponses,
  GetAsGeographicData,
  GetAsGeographicResponses,
  GetCalibrationFileData,
  GetCalibrationFileErrors,
  GetCalibrationFileResponses,
  GetCombinedFactorFromLleData,
  GetCombinedFactorFromLleResponses,
  GetCombinedFactorFromLlhData,
  GetCombinedFactorFromLlhResponses,
  GetCombinedFactorFromNeeData,
  GetCombinedFactorFromNeeResponses,
  GetCombinedFactorFromNehData,
  GetCombinedFactorFromNehResponses,
  GetCombinedFactorFromXyzData,
  GetCombinedFactorFromXyzResponses,
  GetCombinedFactorsData,
  GetCombinedFactorsResponses,
  GetComponentByAliasData,
  GetComponentByAliasResponses,
  GetComponentByCsIdData,
  GetComponentByCsIdResponses,
  GetComponentData,
  GetComponentFileSizeData,
  GetComponentFileSizeResponses,
  GetComponentResponses,
  GetComponentsByAliasData,
  GetComponentsByAliasResponses,
  GetConvergencesData,
  GetConvergencesResponses,
  GetCoordinateSystemBySystemIdsData,
  GetCoordinateSystemBySystemIdsResponses,
  GetCoordinatesystemcomponentsAdminExportsCscmdbData,
  GetCoordinatesystemcomponentsAdminExportsCscmdbResponses,
  GetCoordinatesystemcomponentsAdminExportsCsdxmlData,
  GetCoordinatesystemcomponentsAdminExportsCsdxmlResponses,
  GetCoordinatesystemcomponentsAdminVersionData,
  GetCoordinatesystemcomponentsAdminVersionResponses,
  GetCoordinateSystemData,
  GetCoordinateSystemFromCustomDatumData,
  GetCoordinateSystemFromCustomDatumResponses,
  GetCoordinateSystemResponses,
  GetCsib64Data,
  GetCsib64Errors,
  GetCsib64Responses,
  GetCsibData,
  GetCsibResponses,
  GetData,
  GetDatumData,
  GetDatumResponses,
  GetDatumTransformationData,
  GetDatumTransformationResponses,
  GetDownloadLinksData,
  GetDownloadLinksResponses,
  GetErrors,
  GetFromBase64CsibData,
  GetFromBase64CsibResponses,
  GetFromCsibData,
  GetFromCsibResponses,
  GetFromDcData,
  GetFromDcFileData,
  GetFromDcFileResponses,
  GetFromDcResponses,
  GetFromEpsgData,
  GetFromEpsgResponses,
  GetFromJxlData,
  GetFromJxlFileData,
  GetFromJxlFileResponses,
  GetFromJxlResponses,
  GetFromWktData,
  GetFromWktFileData,
  GetFromWktFileResponses,
  GetFromWktResponses,
  GetGeodataFileSizeData,
  GetGeodataFileSizeResponses,
  GetGeoidData,
  GetGeoidResponses,
  GetGetConvergenceFromLleData,
  GetGetConvergenceFromLleResponses,
  GetGetConvergenceFromLlhData,
  GetGetConvergenceFromLlhResponses,
  GetGetConvergenceFromNeeData,
  GetGetConvergenceFromNeeResponses,
  GetGetConvergenceFromNehData,
  GetGetConvergenceFromNehResponses,
  GetGetConvergenceFromXyzData,
  GetGetConvergenceFromXyzResponses,
  GetJxlByEpsgData,
  GetJxlByEpsgResponses,
  GetJxlData,
  GetJxlResponses,
  GetLleFromLlhData,
  GetLleFromLlhResponses,
  GetLleFromNeeData,
  GetLleFromNeeResponses,
  GetLleFromNehData,
  GetLleFromNehResponses,
  GetLleFromXyzData,
  GetLleFromXyzResponses,
  GetLlhFromLleData,
  GetLlhFromLleResponses,
  GetLlhFromLlhData,
  GetLlhFromLlhResponses,
  GetLlhFromNeeData,
  GetLlhFromNeeResponses,
  GetLlhFromNehData,
  GetLlhFromNehResponses,
  GetLlhFromXyzData,
  GetLlhFromXyzResponses,
  GetNeeFromLleData,
  GetNeeFromLleResponses,
  GetNeeFromLlhData,
  GetNeeFromLlhResponses,
  GetNeeFromNehData,
  GetNeeFromNehResponses,
  GetNeeFromXyzData,
  GetNeeFromXyzResponses,
  GetNehFromLleData,
  GetNehFromLleResponses,
  GetNehFromLlhData,
  GetNehFromLlhResponses,
  GetNehFromNeeData,
  GetNehFromNeeResponses,
  GetNehFromXyzData,
  GetNehFromXyzResponses,
  GetReferenceFrameData,
  GetReferenceFrameResponses,
  GetResponses,
  GetRftibData,
  GetRftibResponses,
  GetScaleFactorFromLleData,
  GetScaleFactorFromLleResponses,
  GetScaleFactorFromLlhData,
  GetScaleFactorFromLlhResponses,
  GetScaleFactorFromNeeData,
  GetScaleFactorFromNeeResponses,
  GetScaleFactorFromNehData,
  GetScaleFactorFromNehResponses,
  GetScaleFactorFromXyzData,
  GetScaleFactorFromXyzResponses,
  GetScaleFactorsData,
  GetScaleFactorsResponses,
  GetShiftGridInfoData,
  GetShiftGridInfoResponses,
  GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCscmdbData,
  GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCscmdbResponses,
  GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCsdxmlData,
  GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCsdxmlResponses,
  GetWktAngularUnitsData,
  GetWktAngularUnitsResponses,
  GetWktData,
  GetWktFromEpsgData,
  GetWktFromEpsgResponses,
  GetWktLinearUnitsData,
  GetWktLinearUnitsResponses,
  GetWktResponses,
  GetXyzFromLleData,
  GetXyzFromLleResponses,
  GetXyzFromLlhData,
  GetXyzFromLlhResponses,
  GetXyzFromNeeData,
  GetXyzFromNeeResponses,
  GetXyzFromNehData,
  GetXyzFromNehResponses,
  GetZoneData,
  GetZoneDefaultDatumData,
  GetZoneDefaultDatumResponses,
  GetZoneDefaultGeoidData,
  GetZoneDefaultGeoidResponses,
  GetZoneGroupData,
  GetZoneGroupResponses,
  GetZoneResponses,
  ListAliasesData,
  ListAliasesResponses,
  ListAllZonesData,
  ListAllZonesResponses,
  ListAreasData,
  ListAreasResponses,
  ListComponentsData,
  ListComponentsResponses,
  ListDatumsData,
  ListDatumsResponses,
  ListFilesData,
  ListFilesResponses,
  ListGeoidsData,
  ListGeoidsResponses,
  ListMySystemsData,
  ListMySystemsResponses,
  ListReferenceFramesData,
  ListReferenceFramesResponses,
  ListSystemsData,
  ListSystemsResponses,
  ListZoneGroupsData,
  ListZoneGroupsResponses,
  ListZonesInGroupData,
  ListZonesInGroupResponses,
  ObsoleteListZonesInGroupData,
  ObsoleteListZonesInGroupResponses,
  PutCoordinatesystemcomponentsCompositionsWktData,
  PutCoordinatesystemcomponentsCompositionsWktResponses,
  PutTenantsByTenantTrnCoordinatesystemcomponentsCompositionsWktData,
  PutTenantsByTenantTrnCoordinatesystemcomponentsCompositionsWktResponses,
  TenantedCreateCoordinateSystemData,
  TenantedCreateCoordinateSystemResponses,
  TenantedDownloadCoordSystemDatabaseData,
  TenantedDownloadCoordSystemDatabaseResponses,
  TenantedDownloadTimeDependentTransformationDatabaseData,
  TenantedGetAliasData,
  TenantedGetAliasResponses,
  TenantedGetAreaData,
  TenantedGetAreaResponses,
  TenantedGetAsGeographicData,
  TenantedGetAsGeographicResponses,
  TenantedGetCalibrationFileData,
  TenantedGetCalibrationFileErrors,
  TenantedGetCalibrationFileResponses,
  TenantedGetCombinedFactorsData,
  TenantedGetCombinedFactorsResponses,
  TenantedGetComponentByAliasData,
  TenantedGetComponentByAliasResponses,
  TenantedGetComponentByCsIdData,
  TenantedGetComponentByCsIdResponses,
  TenantedGetComponentData,
  TenantedGetComponentFileSizeData,
  TenantedGetComponentFileSizeResponses,
  TenantedGetComponentResponses,
  TenantedGetComponentsByAliasData,
  TenantedGetComponentsByAliasResponses,
  TenantedGetConvergencesData,
  TenantedGetConvergencesResponses,
  TenantedGetCoordinateSystemBySystemIdsData,
  TenantedGetCoordinateSystemBySystemIdsResponses,
  TenantedGetCoordinateSystemData,
  TenantedGetCoordinateSystemFromCustomDatumData,
  TenantedGetCoordinateSystemFromCustomDatumResponses,
  TenantedGetCoordinateSystemResponses,
  TenantedGetCsib64Data,
  TenantedGetCsib64Errors,
  TenantedGetCsib64Responses,
  TenantedGetCsibData,
  TenantedGetCsibResponses,
  TenantedGetData,
  TenantedGetDatumData,
  TenantedGetDatumResponses,
  TenantedGetDatumTransformationData,
  TenantedGetDatumTransformationResponses,
  TenantedGetDownloadLinksData,
  TenantedGetDownloadLinksResponses,
  TenantedGetErrors,
  TenantedGetFromBase64CsibData,
  TenantedGetFromBase64CsibResponses,
  TenantedGetFromCsibData,
  TenantedGetFromCsibResponses,
  TenantedGetFromDcData,
  TenantedGetFromDcFileData,
  TenantedGetFromDcFileResponses,
  TenantedGetFromDcResponses,
  TenantedGetFromEpsgData,
  TenantedGetFromEpsgResponses,
  TenantedGetFromJxlData,
  TenantedGetFromJxlFileData,
  TenantedGetFromJxlFileResponses,
  TenantedGetFromJxlResponses,
  TenantedGetFromWktData,
  TenantedGetFromWktFileData,
  TenantedGetFromWktFileResponses,
  TenantedGetFromWktResponses,
  TenantedGetGeodataFileSizeData,
  TenantedGetGeodataFileSizeResponses,
  TenantedGetGeoidData,
  TenantedGetGeoidResponses,
  TenantedGetJxlByEpsgData,
  TenantedGetJxlByEpsgResponses,
  TenantedGetJxlData,
  TenantedGetJxlResponses,
  TenantedGetReferenceFrameData,
  TenantedGetReferenceFrameResponses,
  TenantedGetResponses,
  TenantedGetRftibData,
  TenantedGetRftibResponses,
  TenantedGetScaleFactorsData,
  TenantedGetScaleFactorsResponses,
  TenantedGetShiftGridInfoData,
  TenantedGetShiftGridInfoResponses,
  TenantedGetWktAngularUnitsData,
  TenantedGetWktAngularUnitsResponses,
  TenantedGetWktData,
  TenantedGetWktFromEpsgData,
  TenantedGetWktFromEpsgResponses,
  TenantedGetWktLinearUnitsData,
  TenantedGetWktLinearUnitsResponses,
  TenantedGetWktResponses,
  TenantedGetZoneData,
  TenantedGetZoneDefaultDatumData,
  TenantedGetZoneDefaultDatumResponses,
  TenantedGetZoneDefaultGeoidData,
  TenantedGetZoneDefaultGeoidResponses,
  TenantedGetZoneGroupData,
  TenantedGetZoneGroupResponses,
  TenantedGetZoneResponses,
  TenantedListAliasesData,
  TenantedListAliasesResponses,
  TenantedListAllZonesData,
  TenantedListAllZonesResponses,
  TenantedListAreasData,
  TenantedListAreasResponses,
  TenantedListComponentsData,
  TenantedListComponentsResponses,
  TenantedListDatumsData,
  TenantedListDatumsResponses,
  TenantedListFilesData,
  TenantedListFilesResponses,
  TenantedListGeoidsData,
  TenantedListGeoidsResponses,
  TenantedListReferenceFramesData,
  TenantedListReferenceFramesResponses,
  TenantedListSystemsData,
  TenantedListSystemsResponses,
  TenantedListZoneGroupsData,
  TenantedListZoneGroupsResponses,
  TenantedListZonesInGroupData,
  TenantedListZonesInGroupResponses,
  TenantedTransformCoordinatesData,
  TenantedTransformCoordinatesResponses,
  TenantedTransformToEcefGlobalData,
  TenantedTransformToEcefGlobalResponses,
  TenantedTransformToGlobalData,
  TenantedTransformToGlobalResponses,
  TenantedTransformToLocalData,
  TenantedTransformToLocalResponses,
  TransformCoordinatesData,
  TransformCoordinatesResponses,
  TransformsReadmeData,
  TransformsReadmeResponses,
  TransformToEcefGlobalData,
  TransformToEcefGlobalResponses,
  TransformToGlobalData,
  TransformToGlobalResponses,
  TransformToLocalData,
  TransformToLocalResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const coordinatesReadme = <ThrowOnError extends boolean = false>(
  options?: Options<CoordinatesReadmeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    CoordinatesReadmeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/_README',
    ...options,
  });

export const getNeeFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<GetNeeFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).get<GetNeeFromLlhResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/nee/{neeType}/fromLLH',
      ...options,
    }
  );

export const bulkNeeFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<BulkNeeFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNeeFromLlhResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/nee/{neeType}/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getNeeFromLle = <ThrowOnError extends boolean = false>(
  options: Options<GetNeeFromLleData, ThrowOnError>
) =>
  (options.client ?? client).get<GetNeeFromLleResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/nee/{neeType}/fromLLE',
      ...options,
    }
  );

export const bulkNeeFromLle = <ThrowOnError extends boolean = false>(
  options: Options<BulkNeeFromLleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNeeFromLleResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/nee/{neeType}/fromLLE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getNeeFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<GetNeeFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).get<GetNeeFromXyzResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/nee/{neeType}/fromXYZ',
      ...options,
    }
  );

export const bulkNeeFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<BulkNeeFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNeeFromXyzResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/nee/{neeType}/fromXYZ',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getNeeFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<GetNeeFromNehData, ThrowOnError>
) =>
  (options.client ?? client).get<GetNeeFromNehResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/nee/{neeType}/fromNEH',
      ...options,
    }
  );

export const bulkNeeFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<BulkNeeFromNehData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNeeFromNehResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/nee/{neeType}/fromNEH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getNehFromNee = <ThrowOnError extends boolean = false>(
  options: Options<GetNehFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).get<GetNehFromNeeResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/neh/{nehType}/fromNEE',
      ...options,
    }
  );

export const bulkNehFromNee = <ThrowOnError extends boolean = false>(
  options: Options<BulkNehFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNehFromNeeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/neh/{nehType}/fromNEE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getNehFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<GetNehFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).get<GetNehFromLlhResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/neh/{nehType}/fromLLH',
      ...options,
    }
  );

export const bulkNehFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<BulkNehFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNehFromLlhResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/neh/{nehType}/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getNehFromLle = <ThrowOnError extends boolean = false>(
  options: Options<GetNehFromLleData, ThrowOnError>
) =>
  (options.client ?? client).get<GetNehFromLleResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/neh/{nehType}/fromLLE',
      ...options,
    }
  );

export const bulkNehFromLle = <ThrowOnError extends boolean = false>(
  options: Options<BulkNehFromLleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNehFromLleResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/neh/{nehType}/fromLLE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getNehFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<GetNehFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).get<GetNehFromXyzResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/neh/{nehType}/fromXYZ',
      ...options,
    }
  );

export const bulkNehFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<BulkNehFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkNehFromXyzResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/neh/{nehType}/fromXYZ',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLlhFromNee = <ThrowOnError extends boolean = false>(
  options: Options<GetLlhFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).get<GetLlhFromNeeResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/llh/{llhType}/fromNEE',
      ...options,
    }
  );

export const bulkLlhFromNee = <ThrowOnError extends boolean = false>(
  options: Options<BulkLlhFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLlhFromNeeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/llh/{llhType}/fromNEE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLlhFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<GetLlhFromNehData, ThrowOnError>
) =>
  (options.client ?? client).get<GetLlhFromNehResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/llh/{llhType}/fromNEH',
      ...options,
    }
  );

export const bulkLlhFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<BulkLlhFromNehData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLlhFromNehResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/llh/{llhType}/fromNEH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLlhFromLle = <ThrowOnError extends boolean = false>(
  options: Options<GetLlhFromLleData, ThrowOnError>
) =>
  (options.client ?? client).get<GetLlhFromLleResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/llh/{llhType}/fromLLE',
      ...options,
    }
  );

export const bulkLlhFromLle = <ThrowOnError extends boolean = false>(
  options: Options<BulkLlhFromLleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLlhFromLleResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/llh/{llhType}/fromLLE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLlhFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<GetLlhFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).get<GetLlhFromXyzResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/llh/{llhType}/fromXYZ',
      ...options,
    }
  );

export const bulkLlhFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<BulkLlhFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLlhFromXyzResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/llh/{llhType}/fromXYZ',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLlhFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<GetLlhFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).get<GetLlhFromLlhResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/llh/{llhType}/fromLLH',
      ...options,
    }
  );

export const bulkLlhFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<BulkLlhFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLlhFromLlhResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/llh/{llhType}/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLleFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<GetLleFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).get<GetLleFromLlhResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/lle/{lleType}/fromLLH',
      ...options,
    }
  );

export const bulkLleFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<BulkLleFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLleFromLlhResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/lle/{lleType}/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLleFromNee = <ThrowOnError extends boolean = false>(
  options: Options<GetLleFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).get<GetLleFromNeeResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/lle/{lleType}/fromNEE',
      ...options,
    }
  );

export const bulkLleFromNee = <ThrowOnError extends boolean = false>(
  options: Options<BulkLleFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLleFromNeeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/lle/{lleType}/fromNEE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLleFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<GetLleFromNehData, ThrowOnError>
) =>
  (options.client ?? client).get<GetLleFromNehResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/lle/{lleType}/fromNEH',
      ...options,
    }
  );

export const bulkLleFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<BulkLleFromNehData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLleFromNehResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/lle/{lleType}/fromNEH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getLleFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<GetLleFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).get<GetLleFromXyzResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/lle/{lleType}/fromXYZ',
      ...options,
    }
  );

export const bulkLleFromXyz = <ThrowOnError extends boolean = false>(
  options: Options<BulkLleFromXyzData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkLleFromXyzResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/lle/{lleType}/fromXYZ',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getXyzFromNee = <ThrowOnError extends boolean = false>(
  options: Options<GetXyzFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).get<GetXyzFromNeeResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/xyz/{xyzType}/fromNEE',
      ...options,
    }
  );

export const bulkXyzFromNee = <ThrowOnError extends boolean = false>(
  options: Options<BulkXyzFromNeeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkXyzFromNeeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/xyz/{xyzType}/fromNEE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getXyzFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<GetXyzFromNehData, ThrowOnError>
) =>
  (options.client ?? client).get<GetXyzFromNehResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/xyz/{xyzType}/fromNEH',
      ...options,
    }
  );

export const bulkXyzFromNeh = <ThrowOnError extends boolean = false>(
  options: Options<BulkXyzFromNehData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkXyzFromNehResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/xyz/{xyzType}/fromNEH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getXyzFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<GetXyzFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).get<GetXyzFromLlhResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/xyz/{xyzType}/fromLLH',
      ...options,
    }
  );

export const bulkXyzFromLlh = <ThrowOnError extends boolean = false>(
  options: Options<BulkXyzFromLlhData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkXyzFromLlhResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/xyz/{xyzType}/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getXyzFromLle = <ThrowOnError extends boolean = false>(
  options: Options<GetXyzFromLleData, ThrowOnError>
) =>
  (options.client ?? client).get<GetXyzFromLleResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinates/xyz/{xyzType}/fromLLE',
      ...options,
    }
  );

export const bulkXyzFromLle = <ThrowOnError extends boolean = false>(
  options: Options<BulkXyzFromLleData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BulkXyzFromLleResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/xyz/{xyzType}/fromLLE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getScaleFactorFromLlh = <ThrowOnError extends boolean = false>(
  options?: Options<GetScaleFactorFromLlhData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetScaleFactorFromLlhResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/scaleFactor/fromLLH',
    ...options,
  });

export const bulkScaleFactorFromLlh = <ThrowOnError extends boolean = false>(
  options?: Options<BulkScaleFactorFromLlhData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    BulkScaleFactorFromLlhResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/scaleFactor/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const getScaleFactorFromLle = <ThrowOnError extends boolean = false>(
  options?: Options<GetScaleFactorFromLleData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetScaleFactorFromLleResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/scaleFactor/fromLLE',
    ...options,
  });

export const bulkScaleFactorFromLle = <ThrowOnError extends boolean = false>(
  options?: Options<BulkScaleFactorFromLleData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    BulkScaleFactorFromLleResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/scaleFactor/fromLLE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const getScaleFactorFromXyz = <ThrowOnError extends boolean = false>(
  options?: Options<GetScaleFactorFromXyzData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetScaleFactorFromXyzResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/scaleFactor/fromXYZ',
    ...options,
  });

export const bulkScaleFactorFromXyz = <ThrowOnError extends boolean = false>(
  options?: Options<BulkScaleFactorFromXyzData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    BulkScaleFactorFromXyzResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/scaleFactor/fromXYZ',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const getScaleFactorFromNee = <ThrowOnError extends boolean = false>(
  options?: Options<GetScaleFactorFromNeeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetScaleFactorFromNeeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/scaleFactor/fromNEE',
    ...options,
  });

export const bulkScaleFactorFromNee = <ThrowOnError extends boolean = false>(
  options?: Options<BulkScaleFactorFromNeeData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    BulkScaleFactorFromNeeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/scaleFactor/fromNEE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const getScaleFactorFromNeh = <ThrowOnError extends boolean = false>(
  options?: Options<GetScaleFactorFromNehData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetScaleFactorFromNehResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/scaleFactor/fromNEH',
    ...options,
  });

export const bulkScaleFactorFromNeh = <ThrowOnError extends boolean = false>(
  options?: Options<BulkScaleFactorFromNehData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    BulkScaleFactorFromNehResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/scaleFactor/fromNEH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const getCombinedFactorFromLlh = <ThrowOnError extends boolean = false>(
  options?: Options<GetCombinedFactorFromLlhData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCombinedFactorFromLlhResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/combinedFactor/fromLLH',
    ...options,
  });

export const bulkCombinedFactorFromLlh = <ThrowOnError extends boolean = false>(
  options?: Options<BulkCombinedFactorFromLlhData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    BulkCombinedFactorFromLlhResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/combinedFactor/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const getCombinedFactorFromLle = <ThrowOnError extends boolean = false>(
  options?: Options<GetCombinedFactorFromLleData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCombinedFactorFromLleResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/combinedFactor/fromLLE',
    ...options,
  });

export const bulkCombinedFactorFromLle = <ThrowOnError extends boolean = false>(
  options?: Options<BulkCombinedFactorFromLleData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    BulkCombinedFactorFromLleResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/combinedFactor/fromLLE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const getCombinedFactorFromXyz = <ThrowOnError extends boolean = false>(
  options?: Options<GetCombinedFactorFromXyzData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCombinedFactorFromXyzResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/combinedFactor/fromXYZ',
    ...options,
  });

export const bulkCombinedFactorFromXyz = <ThrowOnError extends boolean = false>(
  options?: Options<BulkCombinedFactorFromXyzData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    BulkCombinedFactorFromXyzResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/combinedFactor/fromXYZ',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const getCombinedFactorFromNee = <ThrowOnError extends boolean = false>(
  options?: Options<GetCombinedFactorFromNeeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCombinedFactorFromNeeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/combinedFactor/fromNEE',
    ...options,
  });

export const bulkCombinedFactorFromNee = <ThrowOnError extends boolean = false>(
  options?: Options<BulkCombinedFactorFromNeeData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    BulkCombinedFactorFromNeeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/combinedFactor/fromNEE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const getCombinedFactorFromNeh = <ThrowOnError extends boolean = false>(
  options?: Options<GetCombinedFactorFromNehData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCombinedFactorFromNehResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/combinedFactor/fromNEH',
    ...options,
  });

export const bulkCombinedFactorFromNeh = <ThrowOnError extends boolean = false>(
  options?: Options<BulkCombinedFactorFromNehData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    BulkCombinedFactorFromNehResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/combinedFactor/fromNEH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const getGetConvergenceFromLlh = <ThrowOnError extends boolean = false>(
  options?: Options<GetGetConvergenceFromLlhData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetGetConvergenceFromLlhResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/convergence/fromLLH',
    ...options,
  });

export const bulkConvergenceFromLlh = <ThrowOnError extends boolean = false>(
  options?: Options<BulkConvergenceFromLlhData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    BulkConvergenceFromLlhResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/convergence/fromLLH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const getGetConvergenceFromLle = <ThrowOnError extends boolean = false>(
  options?: Options<GetGetConvergenceFromLleData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetGetConvergenceFromLleResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/convergence/fromLLE',
    ...options,
  });

export const bulkConvergenceFromLle = <ThrowOnError extends boolean = false>(
  options?: Options<BulkConvergenceFromLleData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    BulkConvergenceFromLleResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/convergence/fromLLE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const getGetConvergenceFromXyz = <ThrowOnError extends boolean = false>(
  options?: Options<GetGetConvergenceFromXyzData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetGetConvergenceFromXyzResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/convergence/fromXYZ',
    ...options,
  });

export const bulkConvergenceFromXyz = <ThrowOnError extends boolean = false>(
  options?: Options<BulkConvergenceFromXyzData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    BulkConvergenceFromXyzResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/convergence/fromXYZ',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const getGetConvergenceFromNee = <ThrowOnError extends boolean = false>(
  options?: Options<GetGetConvergenceFromNeeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetGetConvergenceFromNeeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/convergence/fromNEE',
    ...options,
  });

export const bulkConvergenceFromNee = <ThrowOnError extends boolean = false>(
  options?: Options<BulkConvergenceFromNeeData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    BulkConvergenceFromNeeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/convergence/fromNEE',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const getGetConvergenceFromNeh = <ThrowOnError extends boolean = false>(
  options?: Options<GetGetConvergenceFromNehData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetGetConvergenceFromNehResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/convergence/fromNEH',
    ...options,
  });

export const bulkConvergenceFromNeh = <ThrowOnError extends boolean = false>(
  options?: Options<BulkConvergenceFromNehData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    BulkConvergenceFromNehResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinates/convergence/fromNEH',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const listComponents = <ThrowOnError extends boolean = false>(
  options?: Options<ListComponentsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListComponentsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents',
    ...options,
  });

export const tenantedListComponents = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListComponentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListComponentsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents',
    ...options,
  });

export const listAliases = <ThrowOnError extends boolean = false>(
  options?: Options<ListAliasesData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListAliasesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/aliases',
    ...options,
  });

export const tenantedListAliases = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListAliasesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListAliasesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/aliases',
    ...options,
  });

export const getAlias = <ThrowOnError extends boolean = false>(
  options: Options<GetAliasData, ThrowOnError>
) =>
  (options.client ?? client).get<GetAliasResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/aliases/{aliasID}',
    ...options,
  });

export const tenantedGetAlias = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetAliasData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetAliasResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/aliases/{aliasID}',
    ...options,
  });

export const listAreas = <ThrowOnError extends boolean = false>(
  options?: Options<ListAreasData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListAreasResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/areas',
    ...options,
  });

export const tenantedListAreas = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListAreasData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListAreasResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/areas',
    ...options,
  });

export const getComponent = <ThrowOnError extends boolean = false>(
  options: Options<GetComponentData, ThrowOnError>
) =>
  (options.client ?? client).get<GetComponentResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/{componentID}',
    ...options,
  });

export const tenantedGetComponent = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetComponentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetComponentResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/{componentID}',
    ...options,
  });

export const getComponentByAlias = <ThrowOnError extends boolean = false>(
  options?: Options<GetComponentByAliasData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetComponentByAliasResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/_byAlias',
    ...options,
  });

export const tenantedGetComponentByAlias = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetComponentByAliasData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetComponentByAliasResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/_byAlias',
    ...options,
  });

export const getComponentsByAlias = <ThrowOnError extends boolean = false>(
  options?: Options<GetComponentsByAliasData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetComponentsByAliasResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/_byAlias/all',
    ...options,
  });

export const tenantedGetComponentsByAlias = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetComponentsByAliasData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetComponentsByAliasResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/_byAlias/all',
    ...options,
  });

export const getComponentByCsId = <ThrowOnError extends boolean = false>(
  options?: Options<GetComponentByCsIdData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetComponentByCsIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/_byCsId',
    ...options,
  });

export const tenantedGetComponentByCsId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetComponentByCsIdData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetComponentByCsIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/_byCsId',
    ...options,
  });

export const getArea = <ThrowOnError extends boolean = false>(
  options: Options<GetAreaData, ThrowOnError>
) =>
  (options.client ?? client).get<GetAreaResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/areas/{areaID}',
    ...options,
  });

export const tenantedGetArea = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetAreaData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetAreaResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/areas/{areaID}',
    ...options,
  });

export const listFiles = <ThrowOnError extends boolean = false>(
  options: Options<ListFilesData, ThrowOnError>
) =>
  (options.client ?? client).get<ListFilesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/files/{componentID}',
    ...options,
  });

export const tenantedListFiles = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListFilesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListFilesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/files/{componentID}',
    ...options,
  });

export const getComponentFileSize = <ThrowOnError extends boolean = false>(
  options?: Options<GetComponentFileSizeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetComponentFileSizeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/files/size',
    ...options,
  });

export const tenantedGetComponentFileSize = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetComponentFileSizeData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetComponentFileSizeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/files/size',
    ...options,
  });

export const getCsib = <ThrowOnError extends boolean = false>(
  options?: Options<GetCsibData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetCsibResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/compositions/csib',
    ...options,
  });

export const tenantedGetCsib = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetCsibData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetCsibResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/compositions/csib',
    ...options,
  });

export const getCoordinateSystem = <ThrowOnError extends boolean = false>(
  options?: Options<GetCoordinateSystemData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCoordinateSystemResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/compositions/coordinateSystem',
    ...options,
  });

export const tenantedGetCoordinateSystem = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetCoordinateSystemData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetCoordinateSystemResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/compositions/coordinateSystem',
    ...options,
  });

export const getRftib = <ThrowOnError extends boolean = false>(
  options?: Options<GetRftibData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetRftibResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/compositions/rftib',
    ...options,
  });

export const tenantedGetRftib = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetRftibData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetRftibResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/compositions/rftib',
    ...options,
  });

export const putCoordinatesystemcomponentsCompositionsWkt = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    PutCoordinatesystemcomponentsCompositionsWktData,
    ThrowOnError
  >
) =>
  (options?.client ?? client).put<
    PutCoordinatesystemcomponentsCompositionsWktResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/compositions/wkt',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const putTenantsByTenantTrnCoordinatesystemcomponentsCompositionsWkt = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutTenantsByTenantTrnCoordinatesystemcomponentsCompositionsWktData,
    ThrowOnError
  >
) =>
  (options.client ?? client).put<
    PutTenantsByTenantTrnCoordinatesystemcomponentsCompositionsWktResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/compositions/wkt',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getDatumTransformation = <ThrowOnError extends boolean = false>(
  options?: Options<GetDatumTransformationData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetDatumTransformationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/datumTransformation',
    ...options,
  });

export const tenantedGetDatumTransformation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetDatumTransformationData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetDatumTransformationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystemcomponents/datumTransformation',
    ...options,
  });

export const getCoordinatesystemcomponentsAdminExportsCscmdb = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetCoordinatesystemcomponentsAdminExportsCscmdbData,
    ThrowOnError
  >
) =>
  (options?.client ?? client).get<
    GetCoordinatesystemcomponentsAdminExportsCscmdbResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/admin/exports/cscmdb',
    ...options,
  });

export const getTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCscmdb =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCscmdbData,
      ThrowOnError
    >
  ) =>
    (options.client ?? client).get<
      GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCscmdbResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/tenants/{tenantTrn}/coordinatesystemcomponents/admin/exports/cscmdb',
      ...options,
    });

export const getCoordinatesystemcomponentsAdminExportsCsdxml = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    GetCoordinatesystemcomponentsAdminExportsCsdxmlData,
    ThrowOnError
  >
) =>
  (options?.client ?? client).get<
    GetCoordinatesystemcomponentsAdminExportsCsdxmlResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/admin/exports/csdxml',
    ...options,
  });

export const getTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCsdxml =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCsdxmlData,
      ThrowOnError
    >
  ) =>
    (options.client ?? client).get<
      GetTenantsByTenantTrnCoordinatesystemcomponentsAdminExportsCsdxmlResponses,
      unknown,
      ThrowOnError
    >({
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/tenants/{tenantTrn}/coordinatesystemcomponents/admin/exports/csdxml',
      ...options,
    });

export const getCoordinatesystemcomponentsAdminVersion = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCoordinatesystemcomponentsAdminVersionData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCoordinatesystemcomponentsAdminVersionResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystemcomponents/admin/version',
    ...options,
  });

export const coordinateSystemsReadme = <ThrowOnError extends boolean = false>(
  options?: Options<CoordinateSystemsReadmeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    CoordinateSystemsReadmeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/_README',
    ...options,
  });

export const get = <ThrowOnError extends boolean = false>(
  options?: Options<GetData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetResponses, GetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/byId',
    ...options,
  });

export const tenantedGet = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetResponses,
    TenantedGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/byId',
    ...options,
  });

export const getCsib64 = <ThrowOnError extends boolean = false>(
  options?: Options<GetCsib64Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCsib64Responses,
    GetCsib64Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/csib/base64',
    ...options,
  });

export const tenantedGetCsib64 = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetCsib64Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetCsib64Responses,
    TenantedGetCsib64Errors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/csib/base64',
    ...options,
  });

export const getCalibrationFile = <ThrowOnError extends boolean = false>(
  options?: Options<GetCalibrationFileData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCalibrationFileResponses,
    GetCalibrationFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/calibrationFile',
    ...options,
  });

export const tenantedGetCalibrationFile = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetCalibrationFileData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetCalibrationFileResponses,
    TenantedGetCalibrationFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/calibrationFile',
    ...options,
  });

export const getDownloadLinks = <ThrowOnError extends boolean = false>(
  options?: Options<GetDownloadLinksData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetDownloadLinksResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/downloadLinks',
    ...options,
  });

export const tenantedGetDownloadLinks = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetDownloadLinksData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetDownloadLinksResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/downloadLinks',
    ...options,
  });

export const listSystems = <ThrowOnError extends boolean = false>(
  options?: Options<ListSystemsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListSystemsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems',
    ...options,
  });

export const createCoordinateSystem = <ThrowOnError extends boolean = false>(
  options?: Options<CreateCoordinateSystemData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    CreateCoordinateSystemResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const tenantedListSystems = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListSystemsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListSystemsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems',
    ...options,
  });

export const tenantedCreateCoordinateSystem = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedCreateCoordinateSystemData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedCreateCoordinateSystemResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getCoordinateSystemBySystemIds = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCoordinateSystemBySystemIdsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetCoordinateSystemBySystemIdsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/{zoneSystemId}/{datumSystemId}/{geoidSystemId}',
    ...options,
  });

export const tenantedGetCoordinateSystemBySystemIds = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetCoordinateSystemBySystemIdsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetCoordinateSystemBySystemIdsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/{zoneSystemId}/{datumSystemId}/{geoidSystemId}',
    ...options,
  });

export const getCoordinateSystemFromCustomDatum = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCoordinateSystemFromCustomDatumData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCoordinateSystemFromCustomDatumResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/custom',
    ...options,
  });

export const tenantedGetCoordinateSystemFromCustomDatum = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetCoordinateSystemFromCustomDatumData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetCoordinateSystemFromCustomDatumResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/custom',
    ...options,
  });

export const getFromDcFile = <ThrowOnError extends boolean = false>(
  options?: Options<GetFromDcFileData, ThrowOnError>
) =>
  (options?.client ?? client).put<
    GetFromDcFileResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/imports/dc/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
  });

export const tenantedGetFromDcFile = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromDcFileData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromDcFileResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/dc/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const getFromDc = <ThrowOnError extends boolean = false>(
  options?: Options<GetFromDcData, ThrowOnError>
) =>
  (options?.client ?? client).put<GetFromDcResponses, unknown, ThrowOnError>({
    bodySerializer: null,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/imports/dc',
    ...options,
    headers: {
      'Content-Type': 'text/plain',
      ...options?.headers,
    },
  });

export const tenantedGetFromDc = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromDcData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromDcResponses,
    unknown,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/dc',
    ...options,
    headers: {
      'Content-Type': 'text/plain',
      ...options.headers,
    },
  });

export const getFromJxlFile = <ThrowOnError extends boolean = false>(
  options?: Options<GetFromJxlFileData, ThrowOnError>
) =>
  (options?.client ?? client).put<
    GetFromJxlFileResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/imports/jxl/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
  });

export const tenantedGetFromJxlFile = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromJxlFileData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromJxlFileResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/jxl/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const getFromJxl = <ThrowOnError extends boolean = false>(
  options?: Options<GetFromJxlData, ThrowOnError>
) =>
  (options?.client ?? client).put<GetFromJxlResponses, unknown, ThrowOnError>({
    bodySerializer: null,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/imports/jxl',
    ...options,
    headers: {
      'Content-Type': 'text/plain',
      ...options?.headers,
    },
  });

export const tenantedGetFromJxl = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromJxlData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromJxlResponses,
    unknown,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/jxl',
    ...options,
    headers: {
      'Content-Type': 'text/plain',
      ...options.headers,
    },
  });

export const getFromWktFile = <ThrowOnError extends boolean = false>(
  options?: Options<GetFromWktFileData, ThrowOnError>
) =>
  (options?.client ?? client).put<
    GetFromWktFileResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/imports/wkt/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
  });

export const tenantedGetFromWktFile = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromWktFileData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromWktFileResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/wkt/file',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const getFromWkt = <ThrowOnError extends boolean = false>(
  options?: Options<GetFromWktData, ThrowOnError>
) =>
  (options?.client ?? client).put<GetFromWktResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/imports/wkt',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const tenantedGetFromWkt = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromWktData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromWktResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/wkt',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getFromCsib = <ThrowOnError extends boolean = false>(
  options?: Options<GetFromCsibData, ThrowOnError>
) =>
  (options?.client ?? client).put<GetFromCsibResponses, unknown, ThrowOnError>({
    bodySerializer: null,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/imports/csib',
    ...options,
    headers: {
      'Content-Type': 'application/octet-stream',
      ...options?.headers,
    },
  });

export const tenantedGetFromCsib = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromCsibData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromCsibResponses,
    unknown,
    ThrowOnError
  >({
    bodySerializer: null,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/csib',
    ...options,
    headers: {
      'Content-Type': 'application/octet-stream',
      ...options.headers,
    },
  });

export const getFromBase64Csib = <ThrowOnError extends boolean = false>(
  options?: Options<GetFromBase64CsibData, ThrowOnError>
) =>
  (options?.client ?? client).put<
    GetFromBase64CsibResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/imports/csib/base64',
    ...options,
  });

export const tenantedGetFromBase64Csib = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromBase64CsibData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromBase64CsibResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/csib/base64',
    ...options,
  });

export const getFromEpsg = <ThrowOnError extends boolean = false>(
  options: Options<GetFromEpsgData, ThrowOnError>
) =>
  (options.client ?? client).put<GetFromEpsgResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/imports/epsg/{code}',
    ...options,
  });

export const tenantedGetFromEpsg = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetFromEpsgData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TenantedGetFromEpsgResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/imports/epsg/{code}',
    ...options,
  });

export const getWktFromEpsg = <ThrowOnError extends boolean = false>(
  options: Options<GetWktFromEpsgData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetWktFromEpsgResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/epsg/{code}/wkt',
    ...options,
  });

export const tenantedGetWktFromEpsg = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetWktFromEpsgData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetWktFromEpsgResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/epsg/{code}/wkt',
    ...options,
  });

export const listDatums = <ThrowOnError extends boolean = false>(
  options?: Options<ListDatumsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListDatumsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/datums',
    ...options,
  });

export const tenantedListDatums = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListDatumsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListDatumsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/datums',
    ...options,
  });

export const getDatum = <ThrowOnError extends boolean = false>(
  options: Options<GetDatumData, ThrowOnError>
) =>
  (options.client ?? client).get<GetDatumResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/datums/{systemId}',
    ...options,
  });

export const tenantedGetDatum = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetDatumData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetDatumResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/datums/{systemId}',
    ...options,
  });

export const listReferenceFrames = <ThrowOnError extends boolean = false>(
  options?: Options<ListReferenceFramesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListReferenceFramesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/referenceframes',
    ...options,
  });

export const tenantedListReferenceFrames = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedListReferenceFramesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListReferenceFramesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/referenceframes',
    ...options,
  });

export const getReferenceFrame = <ThrowOnError extends boolean = false>(
  options: Options<GetReferenceFrameData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetReferenceFrameResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/referenceframes/{systemId}',
    ...options,
  });

export const tenantedGetReferenceFrame = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetReferenceFrameData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetReferenceFrameResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/referenceframes/{systemId}',
    ...options,
  });

export const listZoneGroups = <ThrowOnError extends boolean = false>(
  options?: Options<ListZoneGroupsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListZoneGroupsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/zonegroups',
    ...options,
  });

export const tenantedListZoneGroups = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListZoneGroupsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListZoneGroupsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/zonegroups',
    ...options,
  });

export const getZoneGroup = <ThrowOnError extends boolean = false>(
  options: Options<GetZoneGroupData, ThrowOnError>
) =>
  (options.client ?? client).get<GetZoneGroupResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/zonegroups/{systemId}',
    ...options,
  });

export const tenantedGetZoneGroup = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetZoneGroupData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetZoneGroupResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/zonegroups/{systemId}',
    ...options,
  });

/**
 * This route has a typo in it, and will be removed in a future release. Use the 'ListZonesInGroup' route (/coordinatesystems/zonegroups/{systemId:int}/zones) instead.
 *
 * @deprecated
 */
export const obsoleteListZonesInGroup = <ThrowOnError extends boolean = false>(
  options: Options<ObsoleteListZonesInGroupData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ObsoleteListZonesInGroupResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/zonesgroups/{systemId}/zones',
    ...options,
  });

export const listZonesInGroup = <ThrowOnError extends boolean = false>(
  options: Options<ListZonesInGroupData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListZonesInGroupResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/zonegroups/{systemId}/zones',
    ...options,
  });

export const tenantedListZonesInGroup = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListZonesInGroupData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListZonesInGroupResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/zonegroups/{systemId}/zones',
    ...options,
  });

export const listGeoids = <ThrowOnError extends boolean = false>(
  options?: Options<ListGeoidsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListGeoidsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/geoids',
    ...options,
  });

export const tenantedListGeoids = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListGeoidsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListGeoidsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/geoids',
    ...options,
  });

export const getGeoid = <ThrowOnError extends boolean = false>(
  options: Options<GetGeoidData, ThrowOnError>
) =>
  (options.client ?? client).get<GetGeoidResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/geoids/{systemId}',
    ...options,
  });

export const tenantedGetGeoid = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetGeoidData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetGeoidResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/geoids/{systemId}',
    ...options,
  });

export const listAllZones = <ThrowOnError extends boolean = false>(
  options?: Options<ListAllZonesData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListAllZonesResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinatesystems/zones',
      ...options,
    }
  );

export const tenantedListAllZones = <ThrowOnError extends boolean = false>(
  options: Options<TenantedListAllZonesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedListAllZonesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/zones',
    ...options,
  });

export const getZone = <ThrowOnError extends boolean = false>(
  options: Options<GetZoneData, ThrowOnError>
) =>
  (options.client ?? client).get<GetZoneResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/zones/{systemId}',
    ...options,
  });

export const tenantedGetZone = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetZoneData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetZoneResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/zones/{systemId}',
    ...options,
  });

export const getZoneDefaultDatum = <ThrowOnError extends boolean = false>(
  options: Options<GetZoneDefaultDatumData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetZoneDefaultDatumResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/zones/{systemId}/defaultDatum',
    ...options,
  });

export const tenantedGetZoneDefaultDatum = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetZoneDefaultDatumData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetZoneDefaultDatumResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/zones/{systemId}/defaultDatum',
    ...options,
  });

export const getZoneDefaultGeoid = <ThrowOnError extends boolean = false>(
  options: Options<GetZoneDefaultGeoidData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetZoneDefaultGeoidResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/zones/{systemId}/defaultGeoid',
    ...options,
  });

export const tenantedGetZoneDefaultGeoid = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetZoneDefaultGeoidData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetZoneDefaultGeoidResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/zones/{systemId}/defaultGeoid',
    ...options,
  });

export const downloadGeodataFile = <ThrowOnError extends boolean = false>(
  options?: Options<DownloadGeodataFileData, ThrowOnError>
) =>
  (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/geodataFiles',
    ...options,
  });

export const getGeodataFileSize = <ThrowOnError extends boolean = false>(
  options?: Options<GetGeodataFileSizeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetGeodataFileSizeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/geodataFiles/size',
    ...options,
  });

export const tenantedGetGeodataFileSize = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetGeodataFileSizeData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetGeodataFileSizeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/geodataFiles/size',
    ...options,
  });

export const downloadCoordSystemDatabase = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<DownloadCoordSystemDatabaseData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    DownloadCoordSystemDatabaseResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/coordSystemDatabaseFile',
    ...options,
  });

export const tenantedDownloadCoordSystemDatabase = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedDownloadCoordSystemDatabaseData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedDownloadCoordSystemDatabaseResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/coordSystemDatabaseFile',
    ...options,
  });

export const downloadTimeDependentTransformationDatabase = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<
    DownloadTimeDependentTransformationDatabaseData,
    ThrowOnError
  >
) =>
  (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/timeDependentTransformationDatabaseFile',
    ...options,
  });

export const tenantedDownloadTimeDependentTransformationDatabase = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    TenantedDownloadTimeDependentTransformationDatabaseData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<unknown, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/timeDependentTransformationDatabaseFile',
    ...options,
  });

export const getWktAngularUnits = <ThrowOnError extends boolean = false>(
  options?: Options<GetWktAngularUnitsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetWktAngularUnitsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/wkt/angularunits',
    ...options,
  });

export const tenantedGetWktAngularUnits = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetWktAngularUnitsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetWktAngularUnitsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/wkt/angularunits',
    ...options,
  });

export const getWktLinearUnits = <ThrowOnError extends boolean = false>(
  options?: Options<GetWktLinearUnitsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetWktLinearUnitsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/wkt/linearunits',
    ...options,
  });

export const tenantedGetWktLinearUnits = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetWktLinearUnitsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetWktLinearUnitsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/wkt/linearunits',
    ...options,
  });

export const getWkt = <ThrowOnError extends boolean = false>(
  options?: Options<GetWktData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetWktResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/wkt',
    ...options,
  });

export const tenantedGetWkt = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetWktData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetWktResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/wkt',
    ...options,
  });

export const getJxl = <ThrowOnError extends boolean = false>(
  options?: Options<GetJxlData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetJxlResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/jxl',
    ...options,
  });

export const tenantedGetJxl = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetJxlData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetJxlResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/jxl',
    ...options,
  });

export const getAsGeographic = <ThrowOnError extends boolean = false>(
  options?: Options<GetAsGeographicData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetAsGeographicResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/geographic',
    ...options,
  });

export const tenantedGetAsGeographic = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetAsGeographicData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetAsGeographicResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/geographic',
    ...options,
  });

export const getJxlByEpsg = <ThrowOnError extends boolean = false>(
  options?: Options<GetJxlByEpsgData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetJxlByEpsgResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/coordinatesystems/jxl/byEpsg',
      ...options,
    }
  );

export const tenantedGetJxlByEpsg = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetJxlByEpsgData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetJxlByEpsgResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/jxl/byEpsg',
    ...options,
  });

export const getShiftGridInfo = <ThrowOnError extends boolean = false>(
  options?: Options<GetShiftGridInfoData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetShiftGridInfoResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/coordinatesystems/shiftgrids',
    ...options,
  });

export const tenantedGetShiftGridInfo = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetShiftGridInfoData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TenantedGetShiftGridInfoResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/coordinatesystems/shiftgrids',
    ...options,
  });

export const deleteMySystem = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteMySystemData, ThrowOnError>
) =>
  (options?.client ?? client).delete<
    DeleteMySystemResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/mysystems',
    ...options,
  });

export const listMySystems = <ThrowOnError extends boolean = false>(
  options?: Options<ListMySystemsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListMySystemsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/mysystems',
    ...options,
  });

export const addMySystem = <ThrowOnError extends boolean = false>(
  options?: Options<AddMySystemData, ThrowOnError>
) =>
  (options?.client ?? client).post<AddMySystemResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/mysystems',
      ...options,
    }
  );

export const transformsReadme = <ThrowOnError extends boolean = false>(
  options?: Options<TransformsReadmeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    TransformsReadmeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transforms/_README',
    ...options,
  });

export const transformCoordinates = <ThrowOnError extends boolean = false>(
  options?: Options<TransformCoordinatesData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    TransformCoordinatesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transforms/coordinates',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const tenantedTransformCoordinates = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedTransformCoordinatesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedTransformCoordinatesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/transforms/coordinates',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const transformToGlobal = <ThrowOnError extends boolean = false>(
  options?: Options<TransformToGlobalData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    TransformToGlobalResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transforms/globals',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const tenantedTransformToGlobal = <ThrowOnError extends boolean = false>(
  options: Options<TenantedTransformToGlobalData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedTransformToGlobalResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/transforms/globals',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const transformToLocal = <ThrowOnError extends boolean = false>(
  options?: Options<TransformToLocalData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    TransformToLocalResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transforms/locals',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const tenantedTransformToLocal = <ThrowOnError extends boolean = false>(
  options: Options<TenantedTransformToLocalData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedTransformToLocalResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/transforms/locals',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const transformToEcefGlobal = <ThrowOnError extends boolean = false>(
  options?: Options<TransformToEcefGlobalData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    TransformToEcefGlobalResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transforms/globals/ecef',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const tenantedTransformToEcefGlobal = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedTransformToEcefGlobalData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedTransformToEcefGlobalResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/transforms/globals/ecef',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getScaleFactors = <ThrowOnError extends boolean = false>(
  options?: Options<GetScaleFactorsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    GetScaleFactorsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transforms/scaleFactors',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const tenantedGetScaleFactors = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetScaleFactorsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedGetScaleFactorsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/transforms/scaleFactors',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getCombinedFactors = <ThrowOnError extends boolean = false>(
  options?: Options<GetCombinedFactorsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    GetCombinedFactorsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transforms/combinedFactors',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const tenantedGetCombinedFactors = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TenantedGetCombinedFactorsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedGetCombinedFactorsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/transforms/combinedFactors',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const getConvergences = <ThrowOnError extends boolean = false>(
  options?: Options<GetConvergencesData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    GetConvergencesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transforms/convergences',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const tenantedGetConvergences = <ThrowOnError extends boolean = false>(
  options: Options<TenantedGetConvergencesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TenantedGetConvergencesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tenants/{tenantTrn}/transforms/convergences',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });
